import { delay, of } from 'rxjs';

export const focusDelayedRaw = {
	focus: of(true).pipe(delay(300)),
};
/**
 * Returns an expressions with focus as a delayed observable of true.
 * For use in animated slide out dialogs where the focus should be set after the animation is complete,
 * otherwise it does a weird jumpy thing.
 */
export const focusDelayed = {
	expressions: {
		...focusDelayedRaw,
	},
};
